<script>
export default {
    components: {},
};
</script>

<template>
<div>
    <div class="account-pages mt-5">
        <div class="container">
            <slot />
        </div>
    </div>
</div>
</template>
